
      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "NamedResourceEntity": [
      "Company",
      "Store",
      "ESResource",
      "Region"
    ],
    "ExternalEntityMeta": [
      "ExternalPartMeta",
      "ExternalStoreMeta"
    ],
    "TransactionEntity": [
      "Provider",
      "Branch",
      "NamedStore"
    ],
    "StoreInterface": [
      "Branch",
      "NamedStore",
      "Store"
    ],
    "InventoryConnection": [
      "PurchaseOrderConnection"
    ],
    "InventoryEdge": [
      "PurchaseOrderEdge"
    ],
    "Node": [
      "PurchaseOrder",
      "PurchaseOrderItem"
    ],
    "IMutationResult": [
      "ConvertParts__Result",
      "AssignUsersToGroup__Result",
      "RemoveUserFromGroup__Result",
      "UpdateStorePart__Result",
      "CreateBranch__Result",
      "CreateNamedStore__Result",
      "CreateNamedStoreAsChildOf__Result",
      "UpdateStore__Result",
      "ArchiveStore__Result",
      "RentalToStore__Result",
      "StoreToRental__Result",
      "RentalToRentalRetailSale__Result",
      "StoreToRentalRetailSale__Result",
      "AssignPermissionsToRole__Result",
      "RemovePermissionsFromRole__Result",
      "AddPolicyToGroup__Result",
      "RemoveResourcePolicyFromGroup__Result",
      "MergeProviders__Result",
      "MarkProviderAsGloballyVerified__Result",
      "CreatePartCategory__Result",
      "UpdatePartCategory__Result",
      "MergeParts__Result",
      "MarkPartAsGloballyVerified__Result",
      "CreateGroup__Result",
      "DeleteGroup__Result",
      "CreateRole__Result",
      "UpdateRole__Result",
      "DeleteRole__Result",
      "AssignExternalPartId__Result",
      "AssignExternalStoreId__Result",
      "RemoveExternalPartId__Result",
      "RemoveExternalStoreId__Result",
      "InitializeCompany__Result",
      "BatchOperations__Result"
    ],
    "IMutationError": [
      "MutationError"
    ]
  }
};
      export default result;
    